module.exports = __webpack_public_path__ + "img/payment_pc_09.89152896.png";